const toFiniteNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

const parsePriceInput = (value) => {
  if (typeof value !== "string") return toFiniteNumber(value);

  return toFiniteNumber(value.trim().replace(/\./g, "").replace(/,/g, ""));
};

export const calculateAveragePurchasePrice = ({
  stock,
  importQuantity,
  importUnitPrice,
}) => {
  if (!stock) return 0;

  const currentCount = toFiniteNumber(stock.count);
  const currentAveragePrice = toFiniteNumber(stock.avarage_price);
  const currentTotalValue = toFiniteNumber(stock.total_value);
  const incomingQuantity = toFiniteNumber(importQuantity);
  const incomingUnitPrice = parsePriceInput(importUnitPrice);
  const currentInventoryValue =
    currentCount > 0 && currentAveragePrice > 0
      ? currentCount * currentAveragePrice
      : currentTotalValue;
  const nextCount = currentCount + incomingQuantity;

  if (nextCount <= 0) return 0;

  return (
    (currentInventoryValue + incomingQuantity * incomingUnitPrice) / nextCount
  );
};

